<script>
import VueMarkdown from 'vue-markdown'
import { trimMarkdownCodeBlocks } from '@utils/trimMarkdownCodeBlocks'
import { sanitizarHtml } from '@modules/global/utils/sanitizar-html/sanitizar-html'

// Allowlist herdada do `ia-markdown.vue` — que até o merge com
// `claude/feature/chat-ia-visao-imersiva` era o renderizador do chat de IA.
// Este componente virou o renderizador único da plataforma e passou a receber
// o `allow-html` que vinha dele (`chat-message.vue:569`), então a
// sanitização veio junto: trocar de renderizador não pode afrouxar o filtro.
// As listas e a justificativa de cada tag/atributo vivem em
// `@modules/global/utils/sanitizar-html` — dono único, compartilhado.

export default {
  name: 'AawzMarkdownRender',
  components: { VueMarkdown },
  props: {
    source: { type: String, default: '' },
    // allowHtml default FALSE — regra de segurança do CLAUDE.md raiz: todo
    // <VueMarkdown> deve ter :html="false" explícito (payload injetado
    // atravessa fronteiras de equipe via objetos compartilhados). Só liga
    // quem passar allow-html="true" explicitamente (ex: chat-message.vue,
    // quando a persona ativa permiteHtml).
    allowHtml: { type: Boolean, default: false },
    // Negado (default false) em vez de linkify (default true) — regra
    // vue/no-boolean-default do projeto só permite prop boolean default
    // false. Comportamento equivalente: por padrão linkify continua ligado,
    // igual o default do próprio VueMarkdown.
    noLinkify: { type: Boolean, default: false },
    // postrender extra do consumidor (ex: chat-message.vue usa isso pra
    // neutralizarAncoras quando a persona não permite HTML) — roda DEPOIS
    // do trim de blocos de código, que este componente já aplica sozinho.
    postrender: { type: Function, default: null },
  },
  computed: {
    // Ordem: trim de blocos de código → sanitização (só com HTML ligado) →
    // postrender do consumidor. O extra roda por ÚLTIMO, sobre o HTML já
    // limpo; se rodasse antes veria marcação que o DOMPurify ainda vai tirar.
    // Sem `allowHtml` o markdown-it já escapa tudo — a saída é texto, não
    // HTML —, então passar por DOMPurify ali seria custo sem contrapartida.
    postrenderComposto() {
      const higienizar = this.allowHtml
        ? sanitizarHtml
        : (html) => html
      const extra = this.postrender || ((html) => html)
      return (html) => extra(higienizar(trimMarkdownCodeBlocks(html)))
    },
  },
}
</script>

<template>
  <VueMarkdown
    class="markdown-style aawz-markdown-render"
    :source="source"
    :html="allowHtml"
    :linkify="!noLinkify"
    :postrender="postrenderComposto"
  />
</template>
